'use strict';
angular.module('xinhuaQuickPreview', ['xinhuaShareDetailModule']).controller('xinhuaQuickPreviewCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$q',
    '$filter',
    'resCtrModalService',
    '$stateParams',
    '$timeout',
    'trsHttpService',
    'globleParamsSet',
    'trsspliceString',
    'storageListenerService',
    'xinhuaApiService',
    '$sce',
    function(
        $scope,
        $rootScope,
        $state,
        $q,
        $filter,
        resCtrModalService,
        $stateParams,
        $timeout,
        trsHttpService,
        globleParamsSet,
        trsspliceString,
        storageListenerService,
        xinhuaApiService,
        $sce
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                // 分页信息
                CURRPAGE: 1,
                PAGESIZE: 20, // globleParamsSet.setResourceCenterPageSize,
            };
            $scope.status = {
                currModule: 'xhsg',
                screenWrapSelected: false, // 默认收起更多筛选
                showSearchInput: false, // 默认不显示搜索框
                isShowPanel: true, // 默认显示分组列表（仅全部文字）
                isFirstLoad: true, // 是否首次加载页面
                singleGraph: true, // 单图模式：true；多图模式：false
                isOpenedPanel: {
                    // 默认展开第一个
                    // 0: true,
                },
                labels: [], // 所有标签
                selectedLabels: [], // 当前选中的标签
                showRightDetail: false, // 是否显示右侧详情
                curSelected: '', // 当前选中的详情ID
                isPic: $stateParams.ispic == 'true', // 路由判断，是否是图片稿：true图片稿；false文字稿
                // id: $stateParams.id,
                // isneedid: $stateParams.isneedid == 'true' ? true : false, //点击一级栏目以及重点关注二级栏目均需要传id
                // gj_type: $stateParams.gj_type == undefined ? "" : $stateParams.gj_type, //只有重点关注的二级栏目时候需要传gj_type
                fcode: $stateParams.fcode,
                belong: $stateParams.belong,
                imgflag: $stateParams.imgflag,
                // parentFcode: $stateParams.parentfcode, //父类的fcode
                isOnlyXJ: false,
            };
            $scope.basicParams = {
                channelName: $scope.status.currModule,
                typeName: $stateParams.typename,
                // nodeId: $stateParams.nodeid.indexOf(';') < 0 ? $stateParams.nodeid : $stateParams.nodeid.split(';')[0]
            };
            $scope.params = {
                typeid: 'zyzx',
                serviceid: $scope.status.currModule,
                // typeName: $stateParams.typename,
                // nodeId: $stateParams.nodeid.indexOf(';') < 0 ? $stateParams.nodeid : $stateParams.nodeid.split(';')[1],
                // nodename: decodeURIComponent($stateParams.nodename),
                modelId: 'findFromNavigation',
                pageSize: $scope.page.PAGESIZE,
                pageNum: $scope.page.CURRPAGE,
                keyword: {
                    // area: "",
                    // zyzxfield: "",
                    // account: "",
                    time: '',
                    tag: '',
                    // gjType: $scope.status.gj_type,
                    fcode: $scope.status.fcode,
                    belong: $scope.status.belong,
                    imgflag: $scope.status.imgflag,
                    // parentFcode: $scope.status.parentFcode,
                },
                channelName: $scope.basicParams.channelName,
            };
            $scope.data = {
                items: [],
                groups: [],
                selectedArray: [],
                operFlags: [],
                flagTotalItems: [],
                rebuildData: {},
                doctypeArray: [
                    {
                        value: '',
                        name: '全部'
                    },
                    {
                        value: '1',
                        name: '新闻'
                    },
                    {
                        value: '2',
                        name: '图集'
                    }
                ],
                selectedDoctype: {},
                picList: [],
                DomesticOrInternals: [
                    {
                        name: '全部地域',
                        value: '',
                    },
                    {
                        name: '国内',
                        value: 1,
                    },
                    {
                        name: '国外',
                        value: 2,
                    },
                ], // 地域集合
                selectedDomesticOrInternal: {}, // 选中的地域
                selectedClassify: {}, // 选中的分类
            };
            $scope.$root.backSelectedInfo = {}; // 预备给快速预览跳转回普通页面用
            $scope.listParamsForWCM = xinhuaApiService.getDocListParams(); // 如何适应变化？比如默认要当天作为时间筛选
            $scope.listParamsForWCM.OperTimeStart = $scope.data.fromdate;
            $scope.listParamsForWCM.OperTimeEnd = $scope.data.untildate;
            $scope.listParamsForBigdata = xinhuaApiService.getDocListParamsForBigdata();
            $scope.detailParamForWCM = $scope.doctype === '新闻' ? xinhuaApiService.getNewsDetailParams() : xinhuaApiService.getPicDocDetailParams();
        }

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            listenStorage();
            $scope.data.selectedDoctype = $scope.data.doctypeArray[0];
            if ($scope.status.fcode) {
                // 若有默认选中值，则默认选中
                if (angular.isDefined($scope.$root.selectedInfo)) {
                    // 接收新华社稿条件，判断是否有传递的数据
                    if (angular.isDefined($scope.$root.selectedInfo.fromdate)) {
                        $scope.data.fromdate = $scope.$root.backSelectedInfo.fromdate = angular.copy($scope.$root.selectedInfo.fromdate);
                        $scope.data.untildate = $scope.$root.backSelectedInfo.untildate = angular.copy($scope.$root.selectedInfo.untildate);
                        $scope.listParamsForWCM.OperTimeStart = $scope.data.fromdate;
                        $scope.listParamsForWCM.OperTimeEnd = $scope.data.untildate;
                    }
                    if (angular.isDefined($scope.$root.selectedInfo.quickPreviewPageNum)) {
                        $scope.page.CURRPAGE = $scope.$root.backSelectedInfo.quickPreviewPageNum = angular.copy(
                            $scope.$root.selectedInfo.quickPreviewPageNum
                        );
                    }
                }
                if ($state.params.nodename === '通稿新闻线路' || $state.params.nodename === '彩色通稿') {
                    // 根据要求只有这两个分类有数据，暂时写死
                    getDocClassifys().then(() => {
                        requestData();
                    });
                } else {
                    fakeRequests();
                }

                /* });*/
            }
            $scope.$on('$destroy', function() {
                // 销毁对象
                delete $scope.$root.groupData;
                delete $scope.$root.selectedInfo;
                delete $scope.$root.isOpenedPanel;
            });
        }

        /**
         * [fakeRequests description] 因为暂无数据效果不好，发送一个假请求
         * @return  {[type]}  [return description]
         */
        function fakeRequests(){
            if ($scope.status.ESSearch) {
                fakeRequestsForBigdata();
            } else {
                $scope.listParamsForWCM.OperTimeStart = new Date().getDate() + 1;
                $scope.listParamsForWCM.OperTimeEnd = new Date().getDate() + 1;
                requestData();
            }
        }

        /**
         * [fakeRequestsForBigdata description] 因为暂无数据效果不好，发送一个假请求--大数据检索用
         * @return  {[type]}  [return description]
         */
        function fakeRequestsForBigdata() {
            $scope.data.fromdate = new Date().getDate() + 1;
            $scope.data.untildate = new Date().getDate() + 1;
            requestData();
        }

        /**
         * [searchWithKeyword 条件过滤]
         *
         * @param   {[type]}  key    [key description]
         * @param   {[type]}  value  [value description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.searchWithKeyword = function(key, value) {
            if (key === 'docType'){
                // $scope.listParamsForWCM.DocType = value;
                requestData();
            }
        };

        /**
         * [getDocClassifys description] 获取分类
         * @return  {[type]}  [return description]
         */
        function getDocClassifys() {
            var defer = $q.defer();
            var params = xinhuaApiService.getDocClassifyParams();
            xinhuaApiService.getDocClassifys(params).then((data) => {
                $scope.data.classifies = globleParamsSet.dealDropDownData(data, 'DOCCLASSIFYNAME', 'DOCCLASSIFYID');
                $scope.data.classifies.unshift({
                    // 默认添加全部分类
                    name: '全部分类',
                    value: '',
                });
                $scope.data.selectedClassify = angular.copy(data)[0];
                $scope.listParamsForWCM.DocClassifyId = $scope.data.selectedClassify.value;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [clearPageData 清除页面数据]
         *
         * @return  {[type]}  [return description]
         */
        function clearPageData() {
            $scope.data.items = [];
            $scope.data.selectedArray = [];
            $scope.data.picList = [];
        }

        /**
         * [requestData description]请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            clearPageData();
            var params = dealListParams();
            $scope.loadingPromise = xinhuaApiService.getDocList(params).then(function(data) {
                data = xinhuaApiService.dealListData(data);
                $scope.page.PAGECOUNT = data.page.PAGECOUNT;
                $scope.page.ITEMCOUNT = data.page.ITEMCOUNT;
                getFlagList(data.datas);
            });
        }

        $scope.switchPic = function(data){
            console.log(data);
        };

        
        /**
         * [dealListParams 列表参数处理]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParams(){
            let params;
            $scope.status.ESSearch = $scope.status.isOnlyXJ || $scope.status.isKeywordSearch;
            if ($scope.status.ESSearch) {
                params = dealListParamForBigData();
            } else {
                params = dealListParamForWCM();
            }
            return params;
        }

        /**
         * [dealListParamForWCM 从采编获取新华社稿数据]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParamForWCM() {
            
            var params = angular.extend({}, $scope.listParamsForWCM, $scope.page);
            params.DocClassifyId = $scope.status.fcode;
            delete params.PAGECOUNT;
            delete params.ITEMCOUNT;
            return params;
        }

        /**
         * [dealListParamForBigData 处理海贝检索参数]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParamForBigData(){
            let date = '';
            if ($scope.data.fromdate && $scope.data.fromdate !== '') {
                date += $scope.data.fromdate;
            }
            if ($scope.data.untildate && $scope.data.untildate !== '') {
                date += ',' + $scope.data.untildate;
            }
            let searchParams = {
                PAGESIZE: $scope.page.PAGESIZE,
                PAGEINDEX: $scope.page.CURRPAGE,
                searchFields: [
                    {
                        searchField: 'DocClassifyId',
                        keywords: $scope.data.selectedClassify.value || '',
                    },
                    {
                        searchField: 'docType',
                        keywords: $state.params.doctype || '',
                    },
                    {
                        searchField: 'timeType',
                        keywords: date,
                    },
                    {
                        searchField: 'isOnlyXinjiang',
                        keywords: $scope.status.isOnlyXJ,
                    },
                    {
                        searchField: '_sort',
                        keywords: 'time',
                    },
                    {
                        searchField: '',
                        keywords: $scope.data.keywords || '',
                    },
                    {
                        searchField: 'DOMESTICOCINTERNAL',
                        keywords: $scope.data.selectedDomesticOrInternal.value || '',
                    }
                ],
            };
            var bigDataParams = angular.extend({}, $scope.listParamsForBigdata, {
                searchParams: JSON.stringify(searchParams),
            });
            return bigDataParams;
        }

        /**
          * [getFlagList 获取取签标识]
          *
          * @param   {[type]}  listData  [listData description]
          *
          * @return  {[type]}            [return description]
          */
        function getFlagList(listData) {
            let params = xinhuaApiService.getFlagParams();
            params.XHSGSourceIds = trsspliceString.spliceString(listData, 'id', ',');
            $scope.loadingPromise = xinhuaApiService.getFlag(params).then(function(data){
                if (data.length){
                    listData.forEach(function(item, index){
                        data.forEach(function(subitem){
                            if (subitem.XHSGID === item.id){
                                listData[index].flags = subitem;
                            }
                        });
                    });
                }
                $scope.data.items = listData;
                if ($scope.data.items.length) {
                    $scope.detailParamForWCM.XHSGSourceId = $scope.data.items[0].id;
                }
                initDetailData();
            });
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} item      [description] 稿件id
         * @param  {[type]} flagIndex [description] 取签见撤重序号
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function (item, flagIndex) {
            if (item.flags) {
                return item.flags.OPERFLAG.substr(flagIndex, 1) === '1';
            } else {
                return false;
            }
        };

        /**
         * [openTakeDraftModal description] 取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var params = xinhuaApiService.getFetchParams();
            params.XHSGSourceIds = $scope.detailParamForWCM.XHSGSourceId;
            var modalInstance = resCtrModalService.fullTakeDraft(params, false);
            modalInstance.result.then(
                function(data) {
                    storageListenerService.addListenerToResource('takeDraft');
                    initData();
                },
                function() {
                    storageListenerService.addListenerToResource('takeDraft');
                    initData();
                }
            );
        };

         /**
         * [viewInfo description] 取签见撤重 点击弹出
         * @param   {[type]}  ChnlDocId   [ChnlDocId description] 稿件id
         * @param   {[type]}  showRepeat  [showRepeat description] 类型
         * @param   {[type]}  showClick   [showClick description]
         * @param   {[type]}  isUGC       [isUGC description]
         * @return  {[type]}              [return description]
         */
        $scope.viewInfo = function (item) {
            let params = xinhuaApiService.getFlagListParams();
            var operFlags = item.flags.OPERFLAG;
            params.XHSGSourceId = item.id;
            $scope.loadingPromise = xinhuaApiService.getFlagList(params).then(function(data){
                resCtrModalService.operRecordsModal(data, operFlags);
            });
        };

        /**
         * [pageChanged description]分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData();
            $scope.$root.backSelectedInfo.quickPreviewPageNum = $scope.page.CURRPAGE; // 当前页，用于展示普通列表
        };

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initDetailData() {
            if ($scope.doctype === '新闻') {
                $scope.loadingPromise = xinhuaApiService.getNewsDetail($scope.detailParamForWCM).then(function(data){
                    dealSuccessData(data);
                });
            } else {
                $scope.loadingPromise = xinhuaApiService.getNewsDetail($scope.detailParamForWCM).then(function(data){
                    dealSuccessData(data);
                });
            }
        }

        /**
         * [dealSuccessData 处理成功返回后的数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealSuccessData(data){
            $scope.detailInfos = data;
            $scope.detailInfos.content = data && $sce.trustAsHtml($scope.detailInfos.content);
            $scope.keywords = data.keywords === '' ? [] : data.keywords.split('－');
            $scope.data.tags = !data.tags ? [] : data.tags.split(',');
            if ($scope.detailInfos.imgList.length){
                $scope.detailInfos.imgList.forEach(function(item, index){
                    let check = false;
                    if (index === 0) {
                        check = true;
                    }
                    $scope.data.picList.push({
                        PERPICURL: item.PERPICURL,
                        active: check,
                        APPDESC: item.APPDESC,
                    });
                });
            }

        }

        /**
         * [queryByDropdown description] test筛选条件触发后请求数据(时间下拉)
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */

        $scope.queryByDropdown = function(key, value) {
            // if (key === 'OperTime') {
            //     $scope.listParamsForWCM.OperTimeStart = $scope.data.fromdate;
            //     $scope.listParamsForWCM.OperTimeEnd = $scope.data.untildate;
            // }
            requestData();
        };


        /**
         * [dealwithTime description]处理返回时间
         * @param  {[type]} pubTime [description]
         * @return {[type]}         [description]
         */
        $scope.dealwithTime = function(pubTime) {
            if (pubTime !== undefined) {
                return pubTime.replace(/\//g, '-');
            }
            return '';
        };


        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.showDetail = function(item) {
            showDetail(item);
        };

        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        function showDetail(item) {
            $scope.status.showRightDetail = false;
            $scope.detailParamForWCM.XHSGSourceId = item.id;
            $scope.data.picList = [];
            initDetailData();
            
        }

        /**
         * [plainView description] 返回 普通视图
         * @return {[type]} [description]
         */
        $scope.plainView = function() {
            $state.go('front.resourcectrl.xinhua.resource', $stateParams);
        };

        /**
         * [onlyXj 只看新疆操作接口]
         *
         * @return  {[type]}  [return description]
         */
        $scope.onlyXj = function() {
            $scope.status.isOnlyXJ = !$scope.status.isOnlyXJ;
            onlyXj();
        };

        /**
         * [onlyXj 只看新疆实现]
         *
         * @return  {[type]}  [return description]
         */
        function onlyXj() {
            $scope.page.CURRPAGE = 1;
            requestData();
        }
    },
]);
